import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import type { IAppConfigMerchant } from '@modules/merchant/types';

import type {
  DashboardPeriodOptions,
} from '../types';
import {
  DASHBOARD_PERIOD_OPTION_DEFAULT,
} from '../constants';

const useDashboardStore = defineStore('dashboard', () => {
  const selectedPeriod = ref<DashboardPeriodOptions>(DASHBOARD_PERIOD_OPTION_DEFAULT);
  const selectedMerchant = ref<IAppConfigMerchant>();
  const selectedMerchantId = computed<number | undefined>(() => selectedMerchant.value?.id);

  function setPeriod(value: DashboardPeriodOptions): void {
    selectedPeriod.value = value;
  }

  function setMerchant(value: IAppConfigMerchant | undefined): void {
    selectedMerchant.value = value;
  }

  function reset(): void {
    selectedMerchant.value = undefined;
    selectedPeriod.value = DASHBOARD_PERIOD_OPTION_DEFAULT;
  }

  return {
    selectedMerchant,
    selectedPeriod,
    selectedMerchantId,
    reset,
    setPeriod,
    setMerchant,
  };
});

export default useDashboardStore;
